module.exports = __webpack_public_path__ + "img/ing.1688311c.png";